import React, { useEffect, useState } from "react";
import {
  Table,
  Form,
  Spinner,
  Badge,
  Container,
  Button,
  Modal,
  Row,
  Col,
} from "react-bootstrap";
import { MdArrowBackIosNew } from "react-icons/md";
import { MdArrowForwardIos } from "react-icons/md";
import DummyUser from "../../assets/images/dummy_profile.png";
import { MdFilterListAlt } from "react-icons/md";
import { MdFilterAltOff } from "react-icons/md";

const API_URL = process.env.REACT_APP_API_URL;
const LIMIT = 10;

function MyAssociates() {
  const [users, setUsers] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [selectedUser, setSelectedUser] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [statusFilter, setStatusFilter] = useState("");

  const getAuthToken = () => localStorage.getItem("token");

  const [showFilter, setShowFilter] = useState(false);

  const toggleFilter = () => {
    setShowFilter((prev) => !prev);
  };

  const fetchUsers = async (page = 1) => {
    setLoading(true);
    try {
      const token = getAuthToken();
      const url = `${API_URL}/my-child-user?page=${page}&limit=${LIMIT}`;

      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const result = await response.json();
      const fetchedUsers = result.data || [];
      setAllUsers(fetchedUsers);
      setUsers(fetchedUsers);
      setTotalPages(result.totalPages || 1);
      setCurrentPage(page);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers(currentPage);
  }, [currentPage]);

  const filteredAssociates = users.filter((user) => {
    const search = searchTerm.toLowerCase();
    const statusMatch = statusFilter === "" || user.status === statusFilter;
    const searchMatch =
      user.username?.toLowerCase().includes(search) ||
      user.mobile?.toLowerCase().includes(search);
    return statusMatch && searchMatch;
  });

  const handleViewUser = (user) => {
    setSelectedUser(user);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setSelectedUser(null);
    setShowModal(false);
  };

  const toSentenceCase = (text) => {
    if (!text) return "-";
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  return (
    <div className="padding_15">
      <div className="card">
        {/* ═══════════ HEADER ═══════════ */}
        <div className="card-header">
          <div className="d-flex align-items-center justify-content-between">
            <div className="titlepage">
              <h3>My Associates</h3>
            </div>

            {/* ✅ Filter icon — hamesha visible */}
            <button
              type="button"
              className="toggle-filter-btn"
              onClick={toggleFilter}
            >
              {showFilter ? <MdFilterAltOff /> : <MdFilterListAlt />}
            </button>
          </div>
        </div>

        {/* ═══════════ FILTER SECTION ═══════════ */}
        {showFilter && (
          <div className="d-flex gap-2 mb-2 px-3 pt-3">
            <div className="form_design w-100">
              <input
                type="text"
                placeholder="User Name OR Mobile"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="form_design w-100">
              <select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
              >
                <option value="">All Status</option>
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
            </div>
          </div>
        )}

        {/* ═══════════ CARD BODY ═══════════ */}
        <div className="card-body">
          {loading ? (
            <div className="text-center py-5">
              <Spinner animation="border" />
              <p className="mt-3">Loading my Associates...</p>
            </div>
          ) : users.length === 0 ? (
            <p className="text-center text-danger fw-bold">No data found!</p>
          ) : (
            <>
              <div className="table-responsive">
                <Table bordered>
                  <thead className="table-dark">
                    <tr>
                      <th>#</th>
                      <th>Associate Name</th>
                      <th>Associate Mobile</th>
                      <th>Associate Parent Name</th>
                      <th>Associate Parent ID</th>
                      <th>Type</th>
                      <th>KYC Status</th>
                      <th>Status</th>
                      <th>Joining Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredAssociates.map((user, index) => (
                      <tr key={user.id}>
                        <td>{(currentPage - 1) * LIMIT + index + 1}</td>
                        <td>{toSentenceCase(user.username)}</td>
                        <td>{user.mobile}</td>
                        <td>{user.parent_name}</td>
                        <td>{user.parent_id}</td>
                        <td>{toSentenceCase(user.user_type)}</td>
                        <td>
                          <span
                            className={`badge ${
                              user.kyc?.toLowerCase() === "success"
                                ? "bg-success"
                                : user.kyc?.toLowerCase() === "pending"
                                ? "bg-warning text-white"
                                : "bg-custum"
                            }`}
                          >
                            {user.kyc?.toLowerCase() === "success"
                              ? "Complete"
                              : user.kyc?.toLowerCase() === "pending"
                              ? "Pending"
                              : toSentenceCase(user.kyc)}
                          </span>
                        </td>
                        <td>
                          <Badge
                            bg={user.status === "active" ? "custum" : "danger"}
                          >
                            {user.status}
                          </Badge>
                        </td>
                        <td>{user.date}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>

              {/* ═══════════ PAGINATION ═══════════ */}
              <div className="d-flex justify-content-end gap-2 align-items-center">
                <button
                  className="button_pagination"
                  onClick={() =>
                    setCurrentPage((prev) => Math.max(prev - 1, 1))
                  }
                  disabled={currentPage === 1}
                >
                  <MdArrowBackIosNew />
                </button>

                <div className="d-flex gap-2 align-items-center">
                  <p className="pagination_all">{currentPage}</p>
                </div>

                <button
                  className="button_pagination"
                  onClick={() =>
                    setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                  }
                  disabled={currentPage === totalPages}
                >
                  <MdArrowForwardIos />
                </button>
              </div>
            </>
          )}
        </div>
      </div>

      {/* ═══════════ MODAL ═══════════ */}
      {selectedUser && (
        <Modal
          show={showModal}
          size="lg"
          className="modalcontent"
          onHide={handleCloseModal}
          centered
        >
          <div className="d-flex justify-content-between header_modal_design">
            <h3>My Associates Details</h3>
            <Modal.Header closeButton>
              <Modal.Title></Modal.Title>
            </Modal.Header>
          </div>
          <Modal.Body className="text-center">
            <div className="associatedetails">
              <div className="profileimage">
                <img
                  src={
                    selectedUser.profile &&
                    selectedUser.profile !== "null" &&
                    selectedUser.profile !== ""
                      ? `${API_URL}/${selectedUser.profile}`
                      : DummyUser
                  }
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = DummyUser;
                  }}
                  alt="User Profile"
                  className="rounded-circle mb-4"
                />
              </div>

              <div className="text-start">
                <div className="row">
                  <div className="col-md-6 col-12 col-lg-4">
                    <div className="form-group form_modal">
                      <label>Name</label>
                      <input
                        type="text"
                        value={toSentenceCase(selectedUser.username)}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-12 col-lg-4">
                    <div className="form-group form_modal">
                      <label>Mobile</label>
                      <input
                        type="text"
                        value={selectedUser.mobile}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-12 col-lg-4">
                    <div className="form-group form_modal">
                      <label>Email</label>
                      <input
                        type="text"
                        value={selectedUser.email || "-"}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-12 col-lg-4">
                    <div className="form-group form_modal">
                      <label>Address</label>
                      <input
                        type="text"
                        value={toSentenceCase(selectedUser.address || "-")}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-12 col-lg-4">
                    <div className="form-group form_modal">
                      <label>Status</label>
                      <input
                        type="text"
                        value={toSentenceCase(selectedUser.status)}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-12 col-lg-4">
                    <div className="form-group form_modal">
                      <label>DOB</label>
                      <input
                        type="text"
                        value={formatDate(selectedUser.dob)}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-12 col-lg-4">
                    <div className="form-group form_modal">
                      <label>Aadhar</label>
                      <input
                        type="text"
                        value={selectedUser.adhar_number}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-12 col-lg-4">
                    <div className="form-group form_modal">
                      <label>PAN</label>
                      <input
                        type="text"
                        value={selectedUser.pan_number}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-12 col-lg-4">
                    <div className="form-group form_modal">
                      <label>KYC</label>
                      <input
                        type="text"
                        value={toSentenceCase(selectedUser.kyc)}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-12 col-lg-4">
                    <div className="form-group form_modal">
                      <label>Parent Name</label>
                      <input
                        type="text"
                        value={selectedUser.parent_name}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-12 col-lg-4">
                    <div className="form-group form_modal">
                      <label>Parent ID</label>
                      <input
                        type="text"
                        value={selectedUser.parent_id || "-"}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-12 col-lg-4">
                    <div className="form-group form_modal">
                      <label>Register By</label>
                      <input
                        type="text"
                        value={selectedUser.register_by || "-"}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-12 col-lg-4">
                    <div className="form-group form_modal">
                      <label>User Type</label>
                      <input
                        type="text"
                        value={toSentenceCase(selectedUser.user_type)}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-12 col-lg-4">
                    <div className="form-group form_modal">
                      <label>City</label>
                      <input
                        type="text"
                        value={selectedUser.city?.name || "-"}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-12 col-lg-4">
                    <div className="form-group form_modal">
                      <label>Area</label>
                      <input
                        type="text"
                        value={selectedUser.area}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-12 col-lg-4">
                    <div className="form-group form_modal">
                      <label>PinCode</label>
                      <input
                        type="text"
                        value={selectedUser.pincode}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-12 col-lg-4">
                    <div className="form-group form_modal">
                      <label>Whatsapp No</label>
                      <input
                        type="text"
                        value={selectedUser.whatsapp_number}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-12 col-lg-4">
                    <div className="form-group form_modal">
                      <label>Marriage Date</label>
                      <input
                        type="text"
                        value={formatDate(
                          selectedUser.marriage_anniversary_date
                        )}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-12 col-lg-4">
                    <div className="form-group form_modal">
                      <label>RERA Number</label>
                      <input
                        type="text"
                        value={selectedUser.rera_number || "-"}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-12 col-lg-4">
                    <div className="form-group form_modal">
                      <label>First Time Password Change</label>
                      <input
                        type="text"
                        value={
                          selectedUser.first_time_password_change?.toUpperCase() ||
                          "-"
                        }
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </div>
  );
}

export default MyAssociates;